// extracted by mini-css-extract-plugin
export default {"b1":"text_b1__aSZ+k","b2":"text_b2__hiXSw","colorPrimary":"text_colorPrimary__NdNAa","colorSecondary":"text_colorSecondary__XZFPJ"};